<app-cookie-consent *ngIf="(showCookieConsent$ | async)" />
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer />
<app-back-to-top-button />
